import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=1b9fc2eb&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b9fc2eb')) {
      api.createRecord('1b9fc2eb', component.options)
    } else {
      api.reload('1b9fc2eb', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=1b9fc2eb&", function () {
      api.rerender('1b9fc2eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/people/detail.vue"
export default component.exports